import { type ColumnDef } from "@tanstack/react-table"
import { formatDate } from "@utils/formatters"
import type { IPlanTerms } from "@apis/accounts/types"
import { ViewTermsButton } from "./ViewTermsButton"

export const planTermsColumns: ColumnDef<IPlanTerms>[] = [
  { accessorKey: "plan_name", header: "Plan" },

  {
    id: "rate",
    header: "Rate",
    accessorFn: (row) => ({
      rate: row.rate_friendly,
      isIntro: row.is_intro_subscription,
    }),
    cell: ({ getValue }) => {
      const { rate, isIntro } = getValue() as {
        rate: string
        isIntro?: boolean
      }
      return (
        <>
          {isIntro && <span className="tw:mr-1">Intro Period:</span>}
          {rate}
        </>
      )
    },
  },

  {
    accessorKey: "order_dt",
    header: "Order Date",
    cell: ({ getValue }) => {
      const order_dt = getValue<string | null>()
      return <span>{order_dt ? formatDate(order_dt) : "Not Available"}</span>
    },
  },

  {
    accessorKey: "from_dt",
    header: () => (
      <>
        Contract <br />
        From Date
      </>
    ),
    cell: ({ getValue }) => <span>{formatDate(getValue<string>())}</span>,
  },
  {
    accessorKey: "to_dt",
    header: () => (
      <>
        Contract <br />
        To Date
      </>
    ),
    cell: ({ getValue }) => {
      const iso = getValue<string | null>()
      return <span>{iso ? formatDate(iso) : "-"}</span>
    },
  },

  { accessorKey: "reason", header: "Reason" },

  {
    id: "confirmation",
    header: "Confirmation Code",
    cell: ({ row }) => {
      const code = row.original.confirmation_code
      return <span>{code || "Not Available"}</span>
    },
  },
  {
    id: "viewTerms",
    header: "View Terms",
    enableSorting: false,
    cell: ({ row }) => (
      <ViewTermsButton termsArchiveLoc={row.original.terms_archive_loc} />
    ),
  },
]
